
import { AudioManager, Track } from "../../AudioManager";
import {  Point, Size, CreateSpineResources, Rect } from "../../MyHelpers";
import { ResourceIdentifier } from "../../ResourceManager/ResourceIdentifier";
import { IWriteOnlyResourceManager, IReadOnlyResourceManager } from "../../ResourceManager/ResourceManager";
import { Settings } from "../../Settings";
import { ICometInterfacePIXIAPP } from "./ICometInterface";
import * as PIXI from 'pixi.js';
import { JSONResource } from "../../ResourceManager/JSONResource";
import { AtlasResource } from "../../ResourceManager/AtlasResource";
import { Assets } from "pixi.js";
import { IAnimationStateListener, ISkeletonData, Spine } from "@modules/pixi-spine";
import { AwardPositionWithValue, PlayWindow } from "../../api";
import { S2_SpinnableReelsBigCanvas2 } from "../SpinAnimation2/SpinnableReelsBigCanvas2";
import { ParseMonitors } from "../../system/ParseMonitors";
import { IInterval } from "../../Context/Interval";
import { ISystemContext } from "../../Context/SystemContext";

class CometElementSpine {
    //protected skeleton : ISkeletonData = null;    
    protected spine : Spine = null;
    protected view : PIXI.Container = null; 
    protected scalePromX : number = 0;
    protected scalePromY : number = 0;
    protected readonly scale: number = 1.10;
    
    protected spineCompleteListener: IAnimationStateListener = null;
    //protected position : Rect = null;
    public CreateView(skeleton : ISkeletonData , symbolSize:Size , source : Point){
        //this.position = position;
        this.view = new PIXI.Container();    
        this.view.visible = false;
        this.view.renderable = false;
        this.view.position.set(source.x, source.y);    
        this.view.name = "Container-CometSpine";
        this.spine = CreateSpineResources(skeleton);        
        //this.spine.visible = false;
        //this.spine.renderable = false;
        this.spine.state.timeScale = 1.5;
        let scaleWidth = (symbolSize.Width /  600) 
        let scaleHeight = (symbolSize.Height / 500) 
        this.scalePromX= ((scaleHeight + scaleWidth) / 2)* this.scale;
        this.scalePromY = (((scaleHeight + scaleWidth) / 2)* this.scale) * ParseMonitors().AspectFixY;
        this.spine.scale.set(this.scalePromX , this.scalePromY);
        
        this.spineCompleteListener = {
            complete : this.AnimComplete
        }


        this.spine?.state?.addListener(this.spineCompleteListener);
        this.view.addChild(this.spine);       
        scaleWidth = null;
        scaleHeight = null;
    }

    protected AnimComplete = () =>{
        console.log("AnimFinished");
        this.OnCompleteElementCallback?.();
    }

    public View(){
        return this.view;
    }
    public SetPosition(source: Point,dest: Point){
        
        // //dest
        this.view.position.set(source.x, source.y);    
        let ikConstraint = this.spine.skeleton.findBone("target");
        this.spine.visible = true;
        this.spine.renderable = true;
        this.view.visible = true;
        this.view.renderable = true;
       
        ikConstraint.data.x = ((source.x -  dest.x) * -1) /  this.scalePromX;
        ikConstraint.data.y = (source.y-  dest.y) /  this.scalePromY;

        //update bone into spine 
        this.spine?.updateTransform();
        this.spine?.skeleton?.updateWorldTransform();
        this.spine?.skeleton?.setBonesToSetupPose();        
        this.spine.update(0)
        
        this.StartAnim();
    }

    protected StartAnim(){
        this.spine?.state?.setAnimation(0, "pathCollect", false);        
        //this.OnCompleteElementCallback();
    }

    public OnCompleteElementCallback: OnCallBackAnimCometElementFinished = () => null;

    public Destroy() {
        //this.position = null;//update bone into spine 
        this.spine?.updateTransform();
        this.spine?.skeleton?.updateWorldTransform();
        this.spine?.skeleton?.setBonesToSetupPose();        
        this.spine.update(0);
        this.spine?.removeAllListeners();
        this.spine?.removeFromParent();
        if(this.spineCompleteListener) this.spine?.state?.removeListener(this.spineCompleteListener)
        this.spine.destroy({ children: true, texture: false, baseTexture: true });
        this.spine = null;
        this.view.removeFromParent();
        this.view.destroy(true);
        this.view = null;
        this.scalePromX = null;
        this.scalePromY = null;
    }


}
export class CometSpine implements ICometInterfacePIXIAPP {


    protected view: PIXI.Container = null;
    protected audio : AudioManager = null;
    protected resid : ResourceIdentifier = null;
    protected gameName : string = null;
    //protected symbolSize : Size = null;
    protected interval : IInterval = null;
    public constructor(audio : AudioManager , resid : ResourceIdentifier , gameName : string  , systemContex : ISystemContext){
        this.audio = audio;       
        this.resid = resid;
        this.gameName = gameName;
        //this.symbolSize = symbolSize;
       this.interval = systemContex.TimingContext().CreateTimeout("CometTimeOutRevertFlagSkip",500,()=>{
            this.skipComet = false;
        });


        //this.reelsCoverAnotherScreen = reelsCoverAnotherScreen;        
    }

    public ViewPIXIAPP(): PIXI.Container {
        return this.view;
    }

    protected cometElements : CometElementSpine [] = [];
    public CreatePIXIAPP( scatterPositions : AwardPositionWithValue[], spinnableReels2?: S2_SpinnableReelsBigCanvas2): void {
        this.view = new PIXI.Container();
        this.view.name = "CometSpine";
        this.view.visible = true;

        let filterFullAward = scatterPositions.find(s=>s.AwardOptionPosition.Reel > -1 && s.AwardOptionPosition.Row > -1);
        //this.cometElements.CreateView();
        //this.view.addChild(this.cometElements.View());  
        //console.log("ScatterAward:",scatterPositions); 
        this.cometElements = [];
        for (let indexReel = 0; indexReel < scatterPositions.length ; indexReel++) {            
            
                let comet = new CometElementSpine();
                comet.OnCompleteElementCallback = ()  => {
                    console.log("AnimFinished-Jump Next Comet ");
                    if(this.skipComet == true){                        
                        return
                    }
                    this.SpriteComplete();
                    
                //this.SpriteComplete.
            };
            this.cometElements.push(comet);
            //this.cometElements.push(comet);
            let source: Point = null;
            if (filterFullAward != null) source = new Point(0, 0);
            else {
                let symbolRect = spinnableReels2.GetAbsoluteSymbolRectReelRow(filterFullAward[indexReel].AwardOptionPosition.Reel, filterFullAward[indexReel].AwardOptionPosition.ReelOffset);
                source = new Point(symbolRect.centerx, symbolRect.centery);
            }
            
            comet.CreateView(this.skeletonData, spinnableReels2.GetSymbolSize(), source);
            this.view.addChild(comet.View());
        }
        this.skipComet = false;
    }

    protected playWindow : PlayWindow = null;    
    public Destroy() {
        for(let ele of this.cometElements){
            ele.Destroy();
            ele = null;
        };

        this.cometElements = [];
        this.skipComet = null;
        this.view.removeFromParent();
        this.view.destroy(true);
        this.view = null;
    }
    public PrepareResources(resourceManager: IWriteOnlyResourceManager): void {

        resourceManager.Add(new JSONResource(`${Settings.ResourcesFolder}multigame/slot/${this.gameName}/resources/SpineResources/CometPathCollect/Comet_PathCollect.json`, this.resid.ScopedResourceName(`CometSpineFeature-json`)));
        resourceManager.Add(new AtlasResource(`${Settings.ResourcesFolder}multigame/slot/${this.gameName}/resources/SpineResources/CometPathCollect/Comet_PathCollect.atlas`, this.resid.ScopedResourceName(`CometSpineFeature-atlas`)));        
        this.audio.AddTrack(new Track(`${Settings.ResourcesFolder}multigame/slot/common/resources/tracks/cometPathCollect` + Settings.audioFormat, this.resid.ScopedResourceName("cometSpineFeature")));
    }

    
    protected skeletonData : ISkeletonData = null;
    public async ResourcesLoaded(resourceManager: IReadOnlyResourceManager): Promise<void> {
        let jsonResource = resourceManager.Get<JSONResource>(this.resid.ScopedResourceName(`CometSpineFeature-json`));
        let pixiAssetSymbol = await Assets.load(jsonResource.path).finally(() => {
            Assets.cache.remove(jsonResource.path);

        });
        this.skeletonData =  pixiAssetSymbol.spineData;
        //this.cometElements = new CometElementSpine((pixiAssetSymbol.spineData as ISkeletonData));
        //this.cometElements.OnCompleteElementCallback  = this.SpriteComplete.bind(this);

    }
    public Start(source: Point, dest: Point , currentScatterCometIndex): void {
        this.view.visible = true;
        this.cometElements[currentScatterCometIndex].SetPosition(source,dest);
        //this.cometElements[currentScatterCometIndex].StartAnim();
        //this.cometElements.SetPosition(source,dest);
        //this.cometElements.StartAnim();
        //setTimeout(()=>this.SpriteComplete(),1000);      
    }
    public StopsCommets(): void {

    }
    public OnCompleteCallback: OnCallBackCometFeatureFinished = () => null;
    public SpriteComplete(): void {
        //this.canvasSprite.Hide();
        //console.log("AnimAnimFinished - NextComet")
        this.OnCompleteCallback?.();
    }
    public View(): HTMLElement {
        return null;
    }
    public Update(): void {

    }
    public PlayCometSound(): void {
        this.audio.Play(this.resid.ScopedResourceName("cometSpineFeature"),false);
    }
    public StopCometSound(): void {

    }
    public UpdateCometAnimation(celebrationFactor: number) {

    }

    protected skipComet : boolean = false;
    public Skip(currentScatterCometIndex: number , dest : Point , scatterPositions: AwardPositionWithValue[]  , spinnableReels2: S2_SpinnableReelsBigCanvas2 , limitSkip : number = this.cometElements.length) {
        console.log(`SkipComent - ${currentScatterCometIndex} to ${limitSkip}`);
        this.view.visible = true;
        this.skipComet = true;   
        let filterFullAward = scatterPositions.filter(s=>s.AwardOptionPosition.Reel > -1 && s.AwardOptionPosition.Row > -1);
     
        for(let index = currentScatterCometIndex ; index < limitSkip ; index ++){
            let symbolRect = spinnableReels2.GetAbsoluteSymbolRectReelRow(filterFullAward[index].AwardOptionPosition.Reel, filterFullAward[index].AwardOptionPosition.ReelOffset);
            let source: Point = new Point(symbolRect.centerx, symbolRect.centery);
            this.cometElements[index].SetPosition(source,dest);
            //this.cometElements[index].StartAnim();            
        }       

        this.PlayCometSound();

        // setTimeout(() => {
        //     this.skipComet = false;
        // }, 550,)
        this.interval.Start();
    }
    

}

export type OnCallBackAnimCometElementFinished = () => void;
export type OnCallBackCometFeatureFinished = () => void;